const _ = require('lodash')

export const stepsPav = (app) => {
  return [
    {
      label: 'Vos devis',
      stepperLabel: 'Devis',
      groupName: 'devis',
      fields: [
        {
          type: 'file',
          name: 'devis-fichier',
          label: 'Ajouter le devis N°1',
          validation: {
            required: 'Veuillez ajouter le scan ou la photo de vos devis',
          },
        },
        {
          type: 'file',
          name: 'devis-fichier2',
          label: 'Ajouter le devis N°2',
          validation: {
            required: 'Veuillez ajouter le scan ou la photo de vos devis',
          },
        },
        {
          type: 'add-file',
          label: 'Ajouter un autre devis',
          fieldName: 'devis-fichier2',
        },
      ],
    },
    {
      label: 'Validation',
      stepperLabel: 'Validation',
      groupName: 'validation',
      fields: [
        {
          type: 'hidden',
          name: 'producteur',
        },
      ],
    },
  ]
}

export const stepsPecColl = (app) => {
  return [
    {
      label: 'Vos factures acquittées',
      stepperLabel: 'Factures',
      groupName: 'F__factures',
      fields: [
        {
          type: 'date',
          placeholder: '',
          name: 'facture-date',
          label: 'Date de facture',
          validation: { required: 'Veuillez saisir la date de la facture' },
        },
        {
          type: 'text',
          placeholder: '',
          name: 'facture-numero',
          label: 'Numéro de facture',
          validation: { required: 'Veuillez saisir le numéro de la facture' },
        },
        {
          type: 'file',
          name: 'facture-fichier',
          label: 'Scan ou photo de la facture',
          tooltip: {
            id: 'E__factures.facture-fichier',
            title: 'Modèle de facture',
            desc: '',
            src: 'facture.jpg',
          },
          validation: {
            required: 'Veuillez ajouter le scan ou la photo de la facture',
          },
        },
        {
          type: 'file',
          name: 'facture-fichier2',
          disabledFor: [
            '1.26',
            '1.29',
            '3.7.3',
            '3.4.3',
            '3.4.4',
            '3.7.2',
            '3.4.6.3',
            '2.20',
            '3.11.5',
            '2.21',
            '3.4.6',
            '2.29',
          ],
          label: 'Second scan ou photo de la facture',
        },
        {
          type: 'add-file',
          label: 'Ajouter un fichier',
          fieldName: 'facture-fichier',
        },
      ],
    },
    {
      label: 'Relevés bancaires ou preuves de paiements',
      stepperLabel: 'Paiements',
      groupName: 'G__paiements',
      fields: [
        {
          type: 'file',
          name: 'releve-fichier',
          tooltip: {
            id: 'F__releves.releve-fichier',
            title: 'Modèle de relevé',
            desc: '',
            src: 'releve.jpg',
          },
          label: 'Scan(s) ou photo(s)',
          validation: {
            required: 'Veuillez ajouter une ou plusieurs preuves de paiements',
          },
        },
        {
          type: 'add-file',
          label: 'Ajouter un fichier',
          fieldName: 'releve-fichier',
        },
      ],
    },
    {
      label: 'Déclaration',
      stepperLabel: 'Déclaration',
      groupName: 'E__divers',
      fields: [
        {
          type: 'text',
          placeholder: '',
          name: 'surface',
          label: 'surface (en Ha)',
          disabledFor: ['2.20', '3.11.5', '2.21', '2.27', '3.8.2'],
          validation: {
            required: 'Veuillez saisir les informations de surface',
          },
        },
        {
          type: 'select',
          options: app.fiches.map((fiche) => {
            return {
              value: fiche.name,
              label: fiche.name,
              title: fiche.name,
            }
          }),
          name: 'culture',
          label: 'Culture',
          disabledFor: ['2.20', '3.11.5', '2.21', '2.27', '3.8.2'],
          validation: { required: 'Veuillez sélectionner une choix' },
        },
        {
          type: 'text',
          placeholder: '',
          name: 'fournisseur',
          label: 'Fournisseur',
          validation: { required: 'Veuillez aisir un fournisseur' },
        },
        {
          type: 'select',
          options: [
            {
              value: '1 FOIS',
              label: '1 FOIS',
              title: '1 FOIS',
            },
            {
              value: '2 FOIS',
              label: '2 FOIS',
              title: '2 FOIS',
            },
            {
              value: '3 FOIS',
              label: '3 FOIS',
              title: '3 FOIS',
            },
            {
              value: '4 FOIS',
              label: '4 FOIS',
              title: '4 FOIS',
            },
            {
              value: '4 FOIS ET +',
              label: '4 FOIS ET +',
              title: '4 FOIS ET +',
            },
          ],
          name: 'paiement',
          label: 'Paiement en x fois',
          validation: { required: 'Veuillez sélectionner une choix' },
        },
        {
          type: 'select',
          options: [
            {
              value: 'CHEQUE',
              label: 'CHEQUE',
              title: 'CHEQUE',
            },
            {
              value: 'PRÉLÈVEMENT',
              label: 'PRÉLÈVEMENT',
              title: 'PRÉLÈVEMENT',
            },
            {
              value: 'TRAITE',
              label: 'TRAITE',
              title: 'TRAITE',
            },
            {
              value: 'VIREMENT',
              label: 'VIREMENT',
              title: 'VIREMENT',
            },
          ],
          name: 'mode-paiement',
          label: 'Mode de paiement',
          validation: { required: 'Veuillez sélectionner un mode de paiement' },
        },
      ],
    },
    {
      label: 'Rapport d’audit',
      stepperLabel: 'Audits',
      disabledFor: [
        '2.20',
        '2.27',
        '2.29',
        '3.4.6',
        '3.4.4',
        '3.8.2',
        '3.4.6.3',
        '3.6.1',
      ],
      groupName: 'H__audits',
      fields: [
        {
          type: 'file',
          name: 'audit-fichier',
          label: 'Scan(s) ou photo(s)',
          validation: {
            required: "Veuillez ajouter une ou plusieurs rapport d'audit",
          },
        },
        {
          type: 'add-file',
          label: 'Ajouter un fichier',
          fieldName: 'audit-fichier',
        },
      ],
    },
    {
      label: 'Rapport d’analyse',
      stepperLabel: 'Analyses',
      disabledFor: [
        '2.20',
        '3.11.5',
        '2.21',
        '3.4.6',
        '2.29',
        '3.4.4',
        '3.8.2',
        '3.4.6.3',
        '3.6.1',
      ],
      groupName: 'I__analyses',
      fields: [
        {
          type: 'file',
          name: 'analyse-fichier',
          label: 'Scan(s) ou photo(s)',
          validation: {
            required: "Veuillez ajouter une ou plusieurs rapport d'analyse",
          },
        },
        {
          type: 'add-file',
          label: 'Ajouter un fichier',
          fieldName: 'analyse-fichier',
        },
      ],
    },
    {
      label: 'Validation',
      stepperLabel: 'Validation',
      groupName: 'validation',
      fields: [
        {
          type: 'hidden',
          name: 'producteur',
        },
      ],
    },
  ]
}

export const stepsPecInd = (app) => {
  return [
    {
      label: 'Vos factures',
      stepperLabel: 'Factures',
      groupName: 'E__factures', // le X__ Permet d'ordonner les champs dans le recap
      tooltip: {
        id: 'E__factures.facture-fichier',
        title: 'Modèle de facture',
        desc: '',
        src: 'facture.jpg',
      },
      fields: [
        {
          type: 'date',
          placeholder: '',
          name: 'facture-date',
          label: 'Date de facture',
          validation: { required: 'Veuillez saisir la date de la facture' },
        },
        {
          type: 'text',
          placeholder: '',
          name: 'facture-numero',
          label: 'Numéro de facture',
          validation: {
            required: 'Veuillez saisir le numéro de la facture',
          },
        },
        {
          type: 'file',
          name: 'facture-fichier',
          tooltip: {
            id: 'E__factures.facture-fichier',
            title: 'Modèle de facture',
            desc: '',
            src: 'facture.jpg',
          },
          label: 'Scan(s) ou photo(s) de la facture',
          validation: {
            required: 'Veuillez ajouter le scan ou la photo de la facture',
          },
        },
        {
          type: 'file',
          name: 'facture-fichier2',
          disabledFor: [
            '0.0.0',
            '1.26',
            '1.29',
            '1.33',
            '3.7.3',
            '3.4.3',
            '3.4.4',
            '3.7.2',
            '2.20',
            '3.11.5',
            '2.21',
            '3.4.6',
            '2.29',
            '2.16',
            '3.5.8',
          ],
          label: 'Second scan ou photo de la facture',
          validation: {
            required: 'Veuillez ajouter le scan ou la photo de la facture',
          },
        },
        {
          type: 'add-file',
          label: 'Ajouter un fichier',
          fieldName: 'facture-fichier',
        },
      ],
    },
    {
      label: 'Relevés bancaires',
      subLabel:
        'L’identité du détenteur du compte doit obligatoirement apparaitre sur le relevé bancaire.',
      stepperLabel: 'Paiements',
      groupName: 'F__releves', // le X__ Permet d'ordonner les champs dans le recap
      tooltip: {
        id: 'F__releves.releve-fichier',
        title: 'Modèle de relevé',
        desc: '',
        src: 'releve.jpg',
      },
      fields: [
        {
          type: 'select',
          options: [
            {
              value: '1 FOIS',
              label: '1 FOIS',
              title: '1 FOIS',
            },
            {
              value: '2 FOIS',
              label: '2 FOIS',
              title: '2 FOIS',
            },
            {
              value: '3 FOIS',
              label: '3 FOIS',
              title: '3 FOIS',
            },
            {
              value: '4 FOIS',
              label: '4 FOIS',
              title: '4 FOIS',
            },
            {
              value: '4 FOIS ET +',
              label: '4 FOIS ET +',
              title: '4 FOIS ET +',
            },
          ],
          name: 'paiement',
          label: 'Paiement en x fois',
          validation: { required: 'Veuillez sélectionner une choix' },
        },
        {
          type: 'file',
          name: 'releve-fichier',
          label: 'Ajouter un relevé',
          validation: {
            required: 'Veuillez ajouter un scan ou photo de vos releves',
          },
        },
        {
          type: 'add-file',
          label: 'Ajouter un fichier',
          fieldName: 'releve-fichier',
        },
      ],
    },
    {
      label: 'Photos',
      stepperLabel: 'Photos',
      groupName: 'G__photos', // le X__ Permet d'ordonner les champs dans le recap
      fields: [
        {
          type: 'file',
          name: 'photo-fichier',
          label: 'Scan(s) ou photo(s)',
          validation: {
            required: 'Veuillez ajouter une ou plusieurs photos',
          },
        },
        {
          type: 'add-file',
          label: 'Ajouter un fichier',
          fieldName: 'photo-fichier',
        },
      ],
    },
    {
      label: 'Validation',
      stepperLabel: 'Validation',
      fields: [
        {
          type: 'hidden',
          name: 'producteur',
        },
      ],
    },
  ]
}

export const getFilteredSteps = (steps, mesure) => {
  const removeDisabledItems = (data, mesure, depth = 0) => {
    const mesureNumber = mesure //sparseFloat(mesure);

    return data.filter((item) => {
      if (
        item.disabledFor &&
        //!isNaN(mesureNumber) && // Quand les mesures sont en number
        item.disabledFor.includes(mesureNumber)
      ) {
        return false
      }

      if (item.fields) {
        item.fields = removeDisabledItems(item.fields, mesureNumber, depth + 1)
        return item.fields.length > 0
      }

      item.depth = depth
      return true
    })
  }

  return removeDisabledItems(steps, mesure)
}

export const previewImage = (file) => {
  const imageSrc = URL.createObjectURL(file)
  return <img src={imageSrc} className="max-w-full" />
}

// Fonction de log spéciale pour rendre les logs plus visibles
const logDebug = (message, data) => {
  const style = 'background: #2196f3; color: white; font-size: 12px; font-weight: bold; padding: 2px 5px; border-radius: 2px;';
  if (data) {
    console.log(`%c[HELPERS] ${message}`, style, data);
  } else {
    console.log(`%c[HELPERS] ${message}`, style);
  }
};

export const addFileToUpload = (steps, fieldName) => {
  logDebug(`addFileToUpload appelé avec fieldName: ${fieldName}`);
  
  if (!fieldName) {
    logDebug('ERREUR: fieldName est vide ou non défini');
    return steps;
  }
  
  let newSteps = JSON.parse(JSON.stringify(steps)); // Copie profonde
  
  // Trouver l'étape qui contient le champ avec fieldName
  let parentIndex = -1;
  let parent = null;
  
  // D'abord, essayer de trouver le champ par fieldName
  for (let i = 0; i < newSteps.length; i++) {
    const step = newSteps[i];
    const fieldIndex = step.fields.findIndex(field => field.fieldName === fieldName);
    if (fieldIndex !== -1) {
      parentIndex = i;
      parent = step;
      break;
    }
  }
  
  // Si non trouvé, essayer de trouver par le nom du champ
  if (!parent) {
    for (let i = 0; i < newSteps.length; i++) {
      const step = newSteps[i];
      const fieldIndex = step.fields.findIndex(field => field.name === fieldName);
      if (fieldIndex !== -1) {
        parentIndex = i;
        parent = step;
        break;
      }
    }
  }
  
  // Si toujours pas trouvé, essayer de trouver un bouton d'ajout dans n'importe quelle étape
  if (!parent) {
    for (let i = 0; i < newSteps.length; i++) {
      const step = newSteps[i];
      const addFileButton = step.fields.find(field => field.type === 'add-file');
      if (addFileButton) {
        parentIndex = i;
        parent = step;
        break;
      }
    }
  }
  
  if (!parent) {
    logDebug(`ERREUR: Aucune étape trouvée avec un champ ayant fieldName=${fieldName}`);
    logDebug('Structure des étapes', newSteps.map(s => ({ 
      groupName: s.groupName, 
      fields: s.fields.map(f => ({ type: f.type, name: f.name, fieldName: f.fieldName })) 
    })));
    return newSteps;
  }
  
  logDebug(`Étape trouvée: ${parent.groupName} (index ${parentIndex})`);
  
  // Vérifier si l'objet parent a un tableau de champs (fields)
  let fieldsArray = [...parent.fields];
  let fieldId = Date.now();

  // Insérer le nouvel objet dans le tableau de champs (fields)
  let insertIndex = fieldsArray.length - 1;
  if (insertIndex < 0) insertIndex = 0;

  fieldsArray.splice(insertIndex, 0, {
    type: 'file',
    name: `${fieldName}-${fieldId}`,
    label: 'Scan(s) ou photo(s)',
  });

  // On ajoute la date si néçessaire
  if (fieldName === 'facture') {
    fieldsArray.splice(insertIndex, 0, {
      type: 'date',
      name: `facture-date-${fieldName}-${fieldId}`,
      label: 'Date',
    });
  }

  // Mettre à jour l'objet initial avec le nouveau tableau de champs modifié
  newSteps[parentIndex].fields = fieldsArray;
  logDebug(`Champ dynamique ajouté: ${fieldName}-${fieldId}`);
  return newSteps;
}

export function convertToFormData(data) {
  const formData = new FormData()
  // Garder une trace des fichiers déjà traités pour éviter les doublons
  const processedFiles = new Set()

  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key]
      const cleanKey = key.replace(/^.*?__/, '')

      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item instanceof File) {
            formData.append(cleanKey, item)
          } else if (typeof item === 'object' && item !== null) {
            // Vérifier si c'est un objet de fichier de brouillon
            if (item.url && typeof item.url === 'string' && item.isFile) {
              // Pour les fichiers de brouillon, on n'envoie pas le fichier lui-même
              // L'API s'attend à recevoir l'URL du fichier déjà stocké
              formData.append(cleanKey, item.url)
            } else {
              formData.append(cleanKey, JSON.stringify(item))
            }
          } else {
            formData.append(cleanKey, String(item))
          }
        })
      } else if (value instanceof File) {
        formData.append(cleanKey, value)
      } else if (typeof value === 'object' && value !== null) {
        // Traiter les objets
        if (value instanceof Date) {
          // Gérer les dates
          formData.append(cleanKey, value.toISOString())
        } else if (value.url && typeof value.url === 'string' && value.isFile) {
          // Cas spécial pour les objets de fichier chargés depuis un brouillon
          // L'API s'attend à recevoir l'URL du fichier déjà stocké
          // Vérifier si ce fichier a déjà été traité
          const fileId = `${cleanKey}_${value.url}`
          if (!processedFiles.has(fileId)) {
            processedFiles.add(fileId)
            formData.append(cleanKey, value.url)
            console.log(`Fichier de brouillon ajouté: ${cleanKey} -> ${value.url}`)
          }
        } else {
          // Pour les autres objets, parcourir leurs propriétés
          for (const subKey in value) {
            if (value.hasOwnProperty(subKey)) {
              const subValue = value[subKey]
              const subCleanKey = subKey.replace(/^.*?__/, '')
              
              if (subValue instanceof File) {
                formData.append(subCleanKey, subValue)
              } else if (subValue instanceof Date) {
                formData.append(subCleanKey, subValue.toISOString())
              } else if (typeof subValue === 'object' && subValue !== null) {
                // Vérifier si c'est un objet de fichier de brouillon
                if (subValue.url && typeof subValue.url === 'string' && subValue.isFile) {
                  const fileId = `${subCleanKey}_${subValue.url}`
                  if (!processedFiles.has(fileId)) {
                    processedFiles.add(fileId)
                    formData.append(subCleanKey, subValue.url)
                    console.log(`Fichier de brouillon imbriqué ajouté: ${subCleanKey} -> ${subValue.url}`)
                  }
                } else {
                  formData.append(subCleanKey, JSON.stringify(subValue))
                }
              } else if (subValue !== undefined && subValue !== null) {
                formData.append(subCleanKey, String(subValue))
              }
            }
          }
        }
      } else if (value !== undefined && value !== null) {
        formData.append(cleanKey, String(value))
      }
    }
  }

  // Ajouter un log pour déboguer
  console.log('FormData créé:', [...formData.entries()])
  
  return formData
}
